import React from 'react';
import classNames from 'classnames';

import FJArrowCircle from '../../../assets/svg/handle-btn.svg?react';
function FJHandleButton({ onClick, className, style }) {
    return (
        <div onClick={onClick} style={style} className={classNames(className)}>
            <FJArrowCircle />
        </div>
    );
}

export default FJHandleButton;
